import styles from "editor/components/Editor/Editor.css";
import { BLOCK_TYPE } from "config/constants/editor";

export default function(contentBlock) {
  const type = contentBlock.getType();

  switch (type) {
    case BLOCK_TYPE.UNSTYLED:
      // If the block is of the default "unstyled" type, apply a paragraph class to it.
      return styles.paragraph;

    case BLOCK_TYPE.SUBHEAD:
      return styles.subhead;

    case BLOCK_TYPE.AXIOM:
      return styles.axiom;

    default:
      return undefined;
  }
}
